var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5742_59048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 2C11.5948 2 14.5854 4.58651 15.2124 8C14.5854 11.4135 11.5948 14 8.00004 14C4.40525 14 1.4146 11.4135 0.787598 8C1.4146 4.58651 4.40525 2 8.00004 2ZM8.00004 12.6667C10.8238 12.6667 13.24 10.7013 13.8516 8C13.24 5.29869 10.8238 3.33333 8.00004 3.33333C5.17624 3.33333 2.75998 5.29869 2.14836 8C2.75998 10.7013 5.17624 12.6667 8.00004 12.6667ZM8.00004 11C6.34316 11 5.00001 9.65687 5.00001 8C5.00001 6.34315 6.34316 5 8.00004 5C9.65684 5 11 6.34315 11 8C11 9.65687 9.65684 11 8.00004 11ZM8.00004 9.66667C8.92051 9.66667 9.66671 8.92047 9.66671 8C9.66671 7.07953 8.92051 6.33333 8.00004 6.33333C7.07957 6.33333 6.33334 7.07953 6.33334 8C6.33334 8.92047 7.07957 9.66667 8.00004 9.66667Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 2C11.5948 2 14.5854 4.58651 15.2124 8C14.5854 11.4135 11.5948 14 8.00004 14C4.40525 14 1.4146 11.4135 0.787598 8C1.4146 4.58651 4.40525 2 8.00004 2ZM8.00004 12.6667C10.8238 12.6667 13.24 10.7013 13.8516 8C13.24 5.29869 10.8238 3.33333 8.00004 3.33333C5.17624 3.33333 2.75998 5.29869 2.14836 8C2.75998 10.7013 5.17624 12.6667 8.00004 12.6667ZM8.00004 11C6.34316 11 5.00001 9.65687 5.00001 8C5.00001 6.34315 6.34316 5 8.00004 5C9.65684 5 11 6.34315 11 8C11 9.65687 9.65684 11 8.00004 11ZM8.00004 9.66667C8.92051 9.66667 9.66671 8.92047 9.66671 8C9.66671 7.07953 8.92051 6.33333 8.00004 6.33333C7.07957 6.33333 6.33334 7.07953 6.33334 8C6.33334 8.92047 7.07957 9.66667 8.00004 9.66667Z",
    fill: "#516CD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5742_59048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.0617ddfd2dda13b7eb3a5f67dde490a6.svg";
export { ForwardRef as ReactComponent };